module.exports = __webpack_public_path__ + "static/media/basta.f52ba224.PNG";